import { render, staticRenderFns } from "./EnquiryMail.vue?vue&type=template&id=5e45e63d&"
import script from "./EnquiryMail.vue?vue&type=script&lang=js&"
export * from "./EnquiryMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports